import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

export const constantRoutes = [
  {
    path: "/",
    name: "aiPlatform",
    redirect: "/Home",
    component: () => import("@/views/aiPlatform/index.vue"),
    meta: {
      title: "AI生图平台",
      KeepAlive: false,
    },
    children: [
      {
        path: "Home",
        name: "Home",
        component: () => import("@/views/home"),
        meta: {
          title: "AI生图平台",
          KeepAlive: true,
        },
      },
      {
        path: "pdf",
        name: "pdf",
        component: () => import("../components/pdfPreview/pdfPreview.vue"),
        meta: {
          title: "pdf",
          KeepAlive: true,
        },
      },
      {
        path: "GenerateAI",
        name: "GenerateList",
        component: () => import("@/views/GenerateAI/generateList.vue"),
        meta: {
          title: "AI生图平台",
          icon: "",
          KeepAlive: true,
        },
      },
      {
        path: "GeneratePattern",
        name: "GeneratePattern",
        component: () => import("@/views/GeneratePattern/index.vue"),
        meta: {
          title: "爆款图案",
          icon: "",
        },
      },
      {
        path: "inpainter",
        name: "ai-inpainter",
        component: () => import("@/views/Tools"),
        meta: {
          title: "局部重绘",
          icon: "",
        },
      },
      {
        path: "paint/:img?",
        name: "paint",
        component: () => import("@/views/toolkit/paint.vue"),
        meta: {
          title: "涂抹编辑",
          icon: "",
        },
      },
      {
        path: "/backgroundReplace/:img?",
        name: "backgroundReplace",
        component: () => import("@/views/model-scene/backgroundReplace.vue"),
        meta: {
          title: "背景替换",
          icon: "",
        },
      },
      {
        path: "/aiTryOn",
        name: "aiTryOn",
        component: () => import("@/views/model-scene/aiTryOn.vue"),
        meta: {
          title: "AI试衣",
          icon: "",
        },
      },
      {
        path: "/modelScene",
        name: "modelScene",
        component: () => import("@/views/model-scene/modelScene.vue"),
        meta: {
          title: "模特与场景图",
          icon: "",
        },
      },
      {
        path: "/aiGoods",
        name: "aiGoods",
        component: () => import("@/views/aiGoods/index.vue"),
        meta: {
          title: "模特与场景图",
          icon: "",
        },
      },
      {
        path: "modeling",
        name: "modeling",
        component: () => import("@/views/modeling/index.vue"),
        meta: {
          title: "AI试衣",
          icon: "",
        },
      },
      {
        path: "tryOn",
        name: "tryOn",
        component: () => import("@/views/toolkit/tryOn.vue"),
        meta: {
          title: "AI试衣",
          icon: "",
        },
      },
      {
        path: "BackgroundRedrawing/:img?",
        name: "BackgroundRedrawing",
        component: () => import("@/views/toolkit/BackgroundRedrawing.vue"),
        meta: {
          title: "更换背景",
        },
      },
      {
        path: "threeVisions/:img?",
        name: "threeVisions",
        component: () => import("@/views/toolkit/threeVisions.vue"),
        meta: {
          title: "三视图",
        },
      },
      {
        path: "amplify/:img?",
        name: "amplify",
        component: () => import("@/views/toolkit/amplify.vue"),
        props: true,
        meta: {
          title: "无损放大",
        },
      },
      {
        path: "3dmodel/:img?",
        name: "3dmodel",
        component: () => import("@/views/toolkit/3dmodel.vue"),
        meta: {
          title: "转3D模型",
        },
      },
      {
        path: "superZoom/:img?",
        name: "superZoom",
        component: () => import("@/views/toolkit/superZoom.vue"),
        meta: {
          title: "超级放大",
        },
      },
      {
        path: "convert/:img?",
        name: "convert",
        component: () => import("@/views/toolkit/convert.vue"),
        meta: {
          title: "转换格式",
        },
      },
      {
        path: "matting/:img?",
        name: "matting",
        component: () => import("@/views/toolkit/matting.vue"),
        meta: {
          title: "背景移除",
        },
      },
      {
        path: "expand/:img?",
        name: "expand",
        component: () => import("@/views/toolkit/expand.vue"),
        meta: {
          title: "智能扩图",
        },
      },
      {
        path: "enhanceImage/:img?",
        name: "enhanceImage",
        component: () => import("@/views/toolkit/enhanceImage.vue"),
        meta: {
          title: "画质增强",
        },
      },
      {
        path: "instruction/:img?",
        name: "instruction",
        component: () => import("@/views/toolkit/instruction.vue"),
        meta: {
          title: "指令编辑",
        },
      },
      {
        path: "fusion/:img?",
        name: "fusion",
        component: () => import("@/views/toolkit/fusion.vue"),
        meta: {
          title: "智能融图",
        },
      },
      {
        path: "lineart/:img?",
        name: "lineart",
        component: () => import("@/views/toolkit/lineart.vue"),
        meta: {
          title: "线稿渲染",
        },
      },
      {
        path: "lineExtraction/:img?",
        name: "lineExtraction",
        component: () => import("@/views/toolkit/lineExtraction.vue"),
        meta: {
          title: "线稿渲染",
        },
      },
      {
        path: "productFission/:img?",
        name: "productFission",
        component: () => import("@/views/toolkit/productFission.vue"),
        meta: {
          title: "自由仿款",
        },
      },
      {
        path: "imgToVideo/:img?",
        name: "imgToVideo",
        component: () => import("@/views/toolkit/imgToVideo.vue"),
        meta: {
          title: "图转视频",
        },
      },
      {
        path: "extractImage/:img?",
        name: "extractImage",
        component: () => import("@/views/toolkit/extractImage.vue"),
        meta: {
          title: "提取图案",
        },
      },
      {
        path: "styleVariation/:img?",
        name: "styleVariation",
        component: () => import("@/views/toolkit/styleVariation.vue"),
        meta: {
          title: "自定义改款",
        },
      },
      {
        path: "extend/:img?",
        name: "extend",
        component: () => import("@/views/toolkit/extend.vue"),
        meta: {
          title: "系列延伸",
        },
      },
      {
        path: "mix/:img?",
        name: "mix",
        component: () => import("@/views/toolkit/mix.vue"),
        meta: {
          title: "多图融合",
        },
      },
      {
        path: "comFangle/:img?",
        name: "comFangle",
        component: () => import("@/views/toolkit/comFangle.vue"),
        meta: {
          title: "配辅生款",
        },
      },
      {
        path: "imgUse/:img?",
        name: "imgUse",
        component: () => import("@/views/toolkit/imgUse.vue"),
        meta: {
          title: "图片应用",
        },
      },
      {
        path: "singleLineDraw/:img?",
        name: "singleLineDraw",
        component: () => import("@/views/toolkit/singleLineDraw.vue"),
        meta: {
          title: "画单线图",
        },
      },
      {
        path: "operationVideo",
        name: "operationVideo",
        component: () => import("@/views/operationVideo"),
        meta: {
          title: "操作指南",
        },
      },
      {
        path: "productPlanning",
        name: "productPlanning",
        component: () => import("@/views/productPlanning"),
        meta: {
          title: "产品策划",
        },
      },
      {
        path: "productPlanning/schemePage",
        name: "schemePage",
        component: () => import("@/views/productPlanning/schemePage.vue"),
        meta: {
          title: "策划生成",
        },
      },
      {
        path: "productPlanning/schemeHistory",
        name: "schemeHistory",
        component: () => import("@/views/productPlanning/schemeHistory.vue"),
        meta: {
          title: "策划记录",
          KeepAlive: true,
        },
      },
      {
        path: "productPlanning/schemeDetails/:id",
        name: "schemeDetails",
        component: () => import("@/views/productPlanning/schemeDetails.vue"),
        meta: {
          title: "策划详情",
        },
      },
      {
        path: "addSchemeNeed",
        name: "addSchemeNeed",
        component: () => import("@/views/productPlanning/addSchemeNeed"),
        meta: {
          title: "添加推送需求",
        },
      },
      {
        path: "pushList",
        name: "pushList",
        component: () => import("@/views/productPlanning/pushList"),
        meta: {
          title: "推送列表",
          KeepAlive: true,
        },
      },
      {
        path: "alchemyFurnace",
        name: "alchemyFurnace",
        component: () => import("@/views/productPlanning/alchemyFurnace"),
        meta: {
          title: "私有趋势",
        },
      },
      {
        path: "needList",
        name: "needList",
        component: () => import("@/views/productPlanning/needList"),
        meta: {
          title: "需求列表",
          KeepAlive: true,
        },
      },
      {
        path: "trendSchemeDetails",
        name: "trendSchemeDetails",
        component: () => import("@/views/productPlanning/trendSchemeDetails"),
        meta: {
          title: "策划需求详情",
        },
      },
      {
        path: "deepseek",
        name: "deepseek",
        component: () => import("@/views/deepseek"),
        meta: {
          title: "deepseek",
        },
      },
      {
        path: "hotsale-agent",
        name: "hotsaleAgent",
        component: () => import("@/views/faddishImg/index.vue"),
        meta: {
          title: "爆款出图",
          KeepAlive: true,
        },
      },
      {
        path: "aiDesigner",
        name: "aiDesigner",
        component: () => import("@/views/qwwzDesign/index.vue"),
        meta: {
          title: "AI设计",
          KeepAlive: true,
        },
      },
      {
        path: "/chat",
        name: "chat",
        component: () => import("@/views/qwwzDesign/index.vue"),
        meta: {
          title: "智物AI",
          KeepAlive: true,
        },
      },
      {
        path: "PPT-Agent",
        name: "PPTAgent",
        component: () => import("@/views/PPT-Agent/index.vue"),
        meta: {
          title: "提案智能体",
          KeepAlive: true
        }
      },
      {
        path: "manageCenter",
        name: "manageCenter",
        redirect: "/manageCenter/collection",
        component: () => import("@/views/manageCenter/index.vue"),
        meta: {
          title: "管理中心",
          KeepAlive: false,
        },
        children: [
          {
            path: "collection",
            name: "collection",
            component: () => import("@/views/manageCenter/collection/index"),
            meta: {
              title: "我的收藏",
              KeepAlive: true,
            },
          },
          {
            path: "productManage",
            name: "productManage",
            component: () => import("@/views/manageCenter/productManage/index"),
            meta: {
              title: "产品管理",
              KeepAlive: true,
            },
          },
          {
            path: "PointsManage",
            name: "PointsManage",
            component: () =>
              import("@/views/manageCenter/PointsManage/index.vue"),
            meta: {
              title: "点数管理",
              KeepAlive: true,
            },
          },
          {
            path: "BottleModel",
            name: "BottleModel",
            component: () =>
              import("@/views/manageCenter/BottleModel/index.vue"),
            meta: {
              title: "瓶款维护",
              KeepAlive: true,
            },
          },
          {
            path: "MemberManage",
            name: "MemberManage",
            component: () =>
              import("@/views/manageCenter/MemberManage/MemberManage.vue"),
            meta: {
              title: "成员管理",
              KeepAlive: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/GoodsDetails",
    name: "GoodsDetails",
    component: () => import("@/views/faddishImg/goodsDetails.vue"),
    meta: {
      title: "商品详情",
      icon: "",
    },
  },
  {
    path: "/pointDescription",
    name: "PointDescription",
    component: () => import("@/views/pointDescription"),
    meta: {
      title: "消耗点数说明",
      icon: "",
    },
  },
  {
    path: "/show3dModel",
    name: "show3dModel",
    component: () => import("@/views/show3dModel"),
    meta: {
      title: "转3d查看",
      icon: "",
    },
  },
  {
    path: "/404",
    name: "404",
    meta: {
      title: "Not Found",
    },
    component: () => import("@/views/404"),
    hidden: 3,
  },
];

// 动态修改青蛙王子重定向首页
let host = window.location.host;
if (host == "qwwz.iyw.cn") {
  constantRoutes.find(item => item.name == "aiPlatform").redirect = "/Home"
}

// 创建路由实例
const createRouter = () =>
  new VueRouter({
    // mode: 'history', // 启用的话就是去除#
    scrollBehavior: () => ({ y: 0 }),

    routes: constantRoutes,
  });

let router = createRouter();

router.afterEach((to, from) => {
  store.commit("SET_CURRENTTAB", to.name);
});
export default router;
